import React from 'react'

interface CardInfoQtyProps {
    title?: string;
    value?: string | number;
}

const CardInfoQty = ({ title, value }: CardInfoQtyProps) => {
    return (
        <div className='shadowCard  p-3 w-full flex flex-col gap-3 bg-[#F6F6F6]'>
            <p className='title3medium uppercase text-text-blue-200'>{title}</p>
            <p className='title2medium text-black truncate'>{value}</p>
        </div>
    )
}

export default CardInfoQty
